const fetch = require("node-fetch");
const xml2js = require('xml2js');
  //Set up default response
  const response = {
    statusCode: 500,
    body: "Not Implemented",
    headers: {    
      "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0",
      Pragma: "no-cache",
      Expires: "0"
    }
  };

export async function validateGreenId(event) {

  //Identity documents
  const identityOptions = [
    { value: "passportdvs", text: "Australian passport", },
    { value: "birthcertificatedvs", text: "Australian birth certificate" },
    { value: "citizenshipcertificatedvs", text: "Australian citizenship certificate" },
    { value: "immicarddvs", text: "ImmiCard" },
    { value: "medicaredvs", text: "Medicare card" },
    { value: "visadvs", text: "Australian visa (foreign passports)" },
    { value: "centrelinkdvs", text: "Centrelink concession card" },
    { value: "regodvs", text: "Australian driving licence" },
    { value: "actregodvs", text: "ACT driving licence" },
    { value: "nswregodvs", text: "NSW driving licence" },
    { value: "ntregodvs", text: "NT driving licence" },
    { value: "saregodvs", text: "SA driving licence" },
    { value: "qldregodvs", text: "QLD driving licence" },
    { value: "tasregodvs", text: "TAS driving licence" },
    { value: "vicregodvs", text: "VIC driving licence" },
    { value: "waregodvs", text: "WA driving licence" }
  ]

  // Create a new identity verified Director
  if (event.method === "POST") {
    console.log("Create Director");
    const body = JSON.parse(event.body);
    console.log("event.body", body);
    // Configuration
    //const url = configJson.VUE_APP_GI_API_URL;
    const accountId = window.config.VUE_APP_GI_ACC_ID;

    //console.log("zon.VUE_APP_GI_API_URL > ", configJson.VUE_APP_GI_API_URL);
    let verificationId = '';
    //const verificationId = `ttsds-${body.user.email}-${Math.floor(Math.random() * 100)}`;
    const identityVerificationResults = [];

    //Format all the dates correctly
    const dateKeys = [
      "greenid_passportdvs_dob",
      "greenid_birthcertificatedvs_dob",
      "greenid_birthcertificatedvs_registration_date",
      "greenid_birthcertificatedvs_certificate_printed_date",
      "greenid_centrelinkdvs_dob",
      "greenid_citizenshipcertificatedvs_dob",
      "greenid_citizenshipcertificatedvs_acquisition_date",
      "greenid_immicarddvs_dob",
      "greenid_visadvs_dob",
      "greenid_medicaredvs_dob",
      "greenid_nswregodvs_dob",
      "greenid_waregodvs_dob",
      "greenid_vicregodvs_dob",
      "greenid_tasregodvs_dob",
      "greenid_saregodvs_dob",
      "greenid_qldregodvs_dob",
      "greenid_ntregodvs_dob",
      "greenid_actregodvs_dob"
    ];
    for (let i = 0; i < dateKeys.length; i++) {
      if (dateKeys[i] in body.user) {
        var bd = await formatDate(body.user[dateKeys[i]]);
        console.log(dateKeys[i], body.user[dateKeys[i]] = bd.full);
        body.user[dateKeys[i]] = bd.full;
      }
    }
    //Format Medicare date if a Green card
    if(body.user.greenid_medicaredvs_cardColour) {
      const medicare = await formatDate(body.user.greenid_medicaredvs_expiry);
      console.log("MEDICARE", medicare);
      if(body.user.greenid_medicaredvs_cardColour === "G") {
        console.log(body.user.greenid_medicaredvs_cardColour, medicare.monthYear);
        body.user.greenid_medicaredvs_expiry = medicare.monthYear;
      } else {
        console.log(body.user.greenid_medicaredvs_cardColour, medicare.full);
        body.user.greenid_medicaredvs_expiry = medicare.full;
      }
    }

    //Create birthday
    const birthdate = await formatDate(body.user.dateOfBirth);
    console.log("BIRTHDATE", birthdate);

    // 1. Register the GreenID profile
    let registerSchema = `
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:dyn="http://dynamicform.services.registrations.edentiti.com/">
       <soapenv:Header/>
       <soapenv:Body>
          <dyn:registerVerification>
             <accountId>${accountId}</accountId>
             <password>GI_PASSWORD</password>
             <verificationId></verificationId>
             <ruleId>default</ruleId>
             <name>
                <givenName>${body.user.firstName}</givenName>
                <middleNames>${
                  body.user.middleName ? body.user.middleName : ""
                }</middleNames>
                <surname>${body.user.lastName}</surname>
             </name>
             <email>${body.user.email}</email>
             <dob>
                <day>${birthdate.day}</day>
                <month>${birthdate.month}</month>
                <year>${birthdate.year}</year>
             </dob>
             <homePhone></homePhone>
             <workPhone></workPhone>
             <mobilePhone></mobilePhone>
             <deviceIDData></deviceIDData>
            <extraData>
            <name></name>
            <value></value>
            </extraData>
            <generateVerificationToken>true</generateVerificationToken>
          </dyn:registerVerification>
       </soapenv:Body>
    </soapenv:Envelope>
    `;
    console.log("registerSchema", registerSchema);
    console.log("configJson.serverUrl"+window.config.serverUrl)
    let tokenval = localStorage.getItem("id_token");
    const registerResults = await fetchJSON(window.config.serverUrl + '/api/user-details/greenid', {
      method: "POST",
      headers: {
        'Access-Control-Allow-Origin': '*',
        'externalaccess': 'true',
        'serviceId': 'portal',
         'visitId':'portal',
         'password':'portal',
        'ssotoken' : tokenval,
        'Content-Type': 'application/json'
      },
      body: registerSchema
    },err=>{
      console.log("oin error"+JSON.stringify(err))
      console.error(err);

    });

    console.log("registerResults", registerResults);

    if(registerResults) {
      xml2js.parseString(registerResults, (err, result) => {
        if (err) {
          console.log("i am in error..."+JSON.stringify(err))
          console.error(err);
        } else {
          verificationId = result['env:Envelope']['env:Body'][0]['ns2:registerVerificationResponse'][0]['return'][0]['verificationResult'][0]['verificationId'][0];
          console.log(verificationId); // OCBjwviI
        }
      });
    }

    const errorMatch = registerResults.match(
      /<faultcode>env:Server<\/faultcode>/
    );
    if(errorMatch !== null) {
      const errorMessageMatch = registerResults.match(
        /<faultstring>([^<]*)<\/faultstring>/
      );
      console.log(errorMessageMatch[1]);
      response.body = "An error has occurred while attempting to verify your identity. Please contact the department’s Information and Enquiries team on 1800 619 113 (toll free) or at information@earlylearningcommission.nsw.gov.au.";
      response.statusCode = 500;
      //callback(null, response);
    }

    // 2. Submit identity
    for (let i = 0; i < body.identities.length; i++) {
      var inputDetails = [];
      inputDetails.push(
        `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:dyn="http://dynamicform.services.registrations.edentiti.com/"><soapenv:Header/><soapenv:Body><dyn:setFields>`
      );
      if(body.identities[i] === "regodvs") {
        inputDetails.push(
          `<accountId>${accountId}</accountId><password>GI_PASSWORD</password><verificationId>${verificationId}</verificationId><sourceId>${
            body.user.greenid_regodvs_state
          }</sourceId><inputFields>`
        );
        var inputKeys = Object.keys(body.user).filter(word =>
          word.includes(body.user.greenid_regodvs_state)
        );
        for (let j = 0; j < inputKeys.length; j++) {
          inputDetails.push(
            `<input><name>${inputKeys[j]}</name><value>${
              body.user[inputKeys[j]]
            }</value></input>`
          );
        }
      } else {
        inputDetails.push(
          `<accountId>${accountId}</accountId><password>GI_PASSWORD</password><verificationId>${verificationId}</verificationId><sourceId>${
            body.identities[i]
          }</sourceId><inputFields>`
        );
        var inputKeys2 = Object.keys(body.user).filter(word =>
          word.includes(body.identities[i])
        );
        for (let j = 0; j < inputKeys2.length; j++) {
          inputDetails.push(
            `<input><name>${inputKeys2[j]}</name><value>${
              body.user[inputKeys2[j]]
            }</value></input>`
          );
        }
      }
      inputDetails.push(
        `</inputFields></dyn:setFields></soapenv:Body></soapenv:Envelope>`
      );
      let tokenval = localStorage.getItem("id_token");
      console.log("tokenval"+tokenval)

      const inputResults = await fetchJSON(window.config.serverUrl + '/api/user-details/greenid', {
        method: "POST",
        headers: { 
          'Access-Control-Allow-Origin': '*',
          'externalaccess': 'true',
          'serviceId': 'portal',
          'visitId':'portal',
          'password':'portal',
          'ssotoken' : tokenval,
          'Content-Type': 'application/json'
       },
        body: inputDetails.join("")
      });
      console.log("inputDetails", inputDetails.join(""));
      console.log("inputResults", inputResults);

      const errorMatch = inputResults.match(
        /<faultcode>env:Server<\/faultcode>/
      );
      if(errorMatch !== null) {
        const errorMessageMatch = inputResults.match(
          /<faultstring>([^<]*)<\/faultstring>/
        );
        console.log('faultstring', errorMessageMatch[1]);

        const errorMessageDetailsMatch = inputResults.match(
          /<details>([^<]*)<\/details>/
        );
        console.log('details', errorMessageDetailsMatch[1]);
        response.body = "Please confirm your document details or try different documents. The following error was found: " + errorMessageDetailsMatch[1];
        response.statusCode = 500;
        return response;
        //callback(null, response);
      }

      //Everything is perfect, move ahead.
      const resultsMatch = inputResults.match(
        /<checkResult><state>([^<]*)<\/state>/
      );
      console.log("resultsMatch[1]", body.identities[i], resultsMatch[1]);
      identityVerificationResults.push({
        identity: body.identities[i],
        result: resultsMatch[1]
      });
    }

    console.log("identityVerificationResults", identityVerificationResults);

    // 3. Get verification of the result
    let resultSchema = `
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:dyn="http://dynamicform.services.registrations.edentiti.com/">
       <soapenv:Header/>
       <soapenv:Body>
          <dyn:getVerificationResult>
             <accountId>${accountId}</accountId>
             <password>GI_PASSWORD</password>
             <verificationId>${verificationId}</verificationId>
          </dyn:getVerificationResult>
       </soapenv:Body>
    </soapenv:Envelope>
    `;
    console.log("resultSchema", resultSchema);
    tokenval = localStorage.getItem("id_token");

    const verificationResults = await fetchJSON(window.config.serverUrl + '/api/user-details/greenid', {
      method: "POST",
      headers: { 
        'Access-Control-Allow-Origin': '*',
          'externalaccess': true,
          'ssotoken' : tokenval,
          'serviceId': 'portal',
          'visitId':'portal',
          'password':'portal',
          'Content-Type': 'application/json'
    },
      body: resultSchema
    });
    const match = verificationResults.match(
      /<overallVerificationStatus>([^<]*)<\/overallVerificationStatus>/
    );
    console.log("match[1]", match[1]);
    if (match[1] === "IN_PROGRESS" || match[1] === "PENDING") {
      // response.body = JSON.stringify({
      //   verification: match[1],
      //   identities: identityVerificationResults
      // });
      console.log("in if 1", match[1]);
      const verificationErrors = ["IN_PROGRESS", "PENDING"];
      const invalidDocuments = [];
      const invalidIdentities = identityVerificationResults.filter(identity =>
        verificationErrors.includes(identity.result)
      ).map(item => item.identity)
      invalidIdentities.forEach(element => {
        let res = identityOptions.filter(document => document.value === element);
        invalidDocuments.push(res[0].text);
      });
      if(invalidDocuments.length > 1) {
        invalidDocuments.splice(1, 0, "and");
      }
      response.body = "Please confirm your document details or try different documents. The following identity documents could not be verified: " + invalidDocuments.join(' ');
      response.statusCode = 400;
      return response;
      //callback(null, response);
    }
    else if (match[1] === "VERIFIED" || match[1] === "VERIFIED_WITH_CHANGES") {
      console.log("in if 2", match[1]);
      console.log("Create Director");
      const birthdate = await formatDate(body.user.dateOfBirth);
      let schema = {
        schemas: [
          "urn:ietf:params:scim:schemas:core:2.0:User",
          "urn:scim:my:custom:schema"
        ],
        name: {
          familyName: "",
          givenName: ""
        },
        emails: [],
        phoneNumbers: [],
        entitlements: {},
        selectedService: "",
        active: true,
        "urn:scim:my:custom:schema": {
          dateOfBirth: ""
        }
      };
      schema.name.familyName = body.user.lastName;
      schema.name.givenName = body.user.firstName;
      schema.selectedService = "Director";
      schema["urn:scim:my:custom:schema"].dateOfBirth = birthdate.scim;
      schema.emails.push({
        primary: true,
        value: body.user.email,
        type: "work"
      });
      if(body.user.hasOwnProperty("mobile") && body.user.mobile !== "") {
        schema.phoneNumbers.push({"value": body.user.mobile, "type": "mobile"});
      }
      Object.assign(schema.entitlements, { "SE-00000000": "Director" });
      console.log("schema", schema);
      let tokenval = localStorage.getItem("id_token");

      await fetchJSON(window.config.serverUrl + '/api/user-details/idm', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'externalaccess': 'true',
          'serviceId': 'portal',
          'visitId':'portal',
          'password':'portal',
          'ssotoken' : tokenval
        },
        body: JSON.stringify(schema)
      }).then(resp => {
        console.log("IDM response typeof", typeof resp);
        console.log("IDM response parse", JSON.parse(resp));

        console.log("IDM response", JSON.parse(resp).body);
        console.log("IDM response status ", JSON.parse(resp).status);
        
        response.body = JSON.stringify({
          verification: match[1],
          account: resp
        });

        response.statusCode = JSON.parse(resp).status;
        //callback(null, response);
      });
     // response.statusCode=200;
      return response;
    }
    //callback(null, response);
 
  }
}

async function fetchJSON(url, options) {

  const response = await fetch(url, options);
  const results = await response.text();
  if (url === window.config.IDM_API_URL) {
    return { finalData: results, statusCode: response.status };
  }

  return results;
}

async function formatDate(timestamp) {
  const date = new Date(timestamp);
  const day = date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    day: "2-digit"
  });
  const month = date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    month: "2-digit"
  });
  const year = date.toLocaleString("en-AU", {
    timeZone: "Australia/Sydney",
    year: "numeric"
  });
  return {
    timestamp: timestamp,
    date: date.toLocaleString("en-AU", { timeZone: "Australia/Sydney" }),
    day: day,
    month: month,
    year: year,
    full: `${day}/${month}/${year}`,
    scim: `${year}${month}${day}`,
    monthYear: `${month}/${year}`
  };
}